<template>
    <carousel 
    :autoplay="true"
    :autoplayHoverPause="true"
    :perPage="1"
    :autoplayTimeout="5000"
    :loop="true"
    :paginationEnabled="false">
    <slide v-for="(dat,n) in data" :key="n">
        <figure class="image is-3by1">
            <img :src="dat.src" :alt="dat.alt" :title="dat.title">
        </figure>
    </slide>
    </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name:'VueCarousel',
    props: {
        data: {
            type: Array,
            default:()=>([])
        }
    },
    components: {
        Carousel,
        Slide
    }
}
</script>

<style>

</style>